import { memo } from "react";

export const PackageProtectionDetails = memo(
  function PackageProtectionDetails() {
    return null;
  },
);
